import { withInstall } from '@tav-ui/utils/with-install'
import CountButton from './src/count-button.vue'
const TaCountButton = withInstall(CountButton)
export { TaCountButton }
export default TaCountButton
export * from './src/types'
